import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations.js'
import actions from './actions.js'

Vue.use(Vuex)

const state = {
  user: {
    id:0,
    email: "",        	
    pass: "",         	
    name: "",         	
    avatar: "",         
    bean: 0,          	
    invite: "",       	
    level: 0,         	
    steam: "",        	
	promotion_level:"", 
	total_recharge:"",    
  vip_exp:"", 
	Rebate:"",            
	reg_freeze_bean:"",   
	recharge_level:"",    
	charge_rebate:"",     
	integral:"",          
	state: false,     
  anchor_icon:0,
  },
  
  roundNum:0,
  
  VsKaiShi:{},
  
  VsJieShu:{},
  
  RegisterShow: false,
  SignInShow: false,
  
  KaiShiVsData:{},
  JieShuVsData:{},
  
  
  AddInformation:{},
  

  IndividualsShow:false
  
}


const getters = {

}


export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
